import React from 'react';

import { IconProps } from '../../Icon.types';

export const ReferenceIcon = (props: IconProps) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.467 1.59961C11.6143 1.59961 12.1726 1.70743 12.753 2.01779C13.2812 2.30031 13.6994 2.71849 13.9819 3.24675C14.2923 3.82708 14.4001 4.38542 14.4001 5.53266V10.4666C14.4001 11.6138 14.2923 12.1721 13.9819 12.7525C13.6994 13.2807 13.2812 13.6989 12.753 13.9814C12.1726 14.2918 11.6143 14.3996 10.467 14.3996H5.53315C4.38591 14.3996 3.82757 14.2918 3.24724 13.9814C2.71897 13.6989 2.3008 13.2807 2.01828 12.7525C1.70792 12.1721 1.6001 11.6138 1.6001 10.4666V5.53266C1.6001 4.38542 1.70792 3.82708 2.01828 3.24675C2.3008 2.71849 2.71897 2.30031 3.24724 2.01779C3.82757 1.70743 4.38591 1.59961 5.53315 1.59961H10.467ZM10.467 2.79961H5.53315C4.56707 2.79961 4.19588 2.87129 3.81316 3.07597C3.49401 3.24665 3.24714 3.49353 3.07646 3.81267C2.87178 4.19539 2.8001 4.56658 2.8001 5.53266V10.4666C2.8001 11.4326 2.87178 11.8038 3.07646 12.1865C3.24714 12.5057 3.49401 12.7526 3.81316 12.9232C4.19588 13.1279 4.56707 13.1996 5.53315 13.1996H10.467C11.4331 13.1996 11.8043 13.1279 12.187 12.9232C12.5062 12.7526 12.7531 12.5057 12.9237 12.1865C13.1284 11.8038 13.2001 11.4326 13.2001 10.4666V5.53266C13.2001 4.56658 13.1284 4.19539 12.9237 3.81267C12.7531 3.49353 12.5062 3.24665 12.187 3.07597C11.8043 2.87129 11.4331 2.79961 10.467 2.79961Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 6.99961C8.33147 6.99961 8.6001 7.26824 8.6001 7.59961V10.7996C8.6001 11.131 8.33147 11.3996 8.0001 11.3996C7.66873 11.3996 7.4001 11.131 7.4001 10.7996V7.59961C7.4001 7.26824 7.66873 6.99961 8.0001 6.99961Z"
        fill={props.color}
      />
      <path
        d="M8.8001 5.19961C8.8001 5.64144 8.44193 5.99961 8.0001 5.99961C7.55827 5.99961 7.2001 5.64144 7.2001 5.19961C7.2001 4.75778 7.55827 4.39961 8.0001 4.39961C8.44193 4.39961 8.8001 4.75778 8.8001 5.19961Z"
        fill={props.color}
      />
    </svg>
  );
};
